module.exports = __webpack_public_path__ + "static/cunard-logo-ecd4eae1aa2094b6758e004c8e6086ce.svg";